module.exports = __webpack_public_path__ + "static/media/Fernando-Chavez.da9e0419.jpg";